<div class="dropdown-search-filter-contianer is-flex-desktop is-flex-tablet mb-3">
  <div class="dropdown mr-2"
       [class.is-active]="isOpen"
       (portalClickOutside)="isOpen = false"
  >
    <div class="dropdown-trigger">
      <button
        [attr.aria-expanded]="isOpen"
        class="button has-background-light has-text-grey-darker"
        type="button"
        (click)="toggleDropdown()"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        title="{{ label }}"
      >
        <span class="has-text-truncate">{{ label }}</span>
        <span class="icon">
          <i
            class="fas fa-chevron-down"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
    <div
      class="dropdown-menu"
      id="dropdown-menu"
      role="menu"
    >
      <div class="dropdown-content">
        <div class="dropdown-item is-scrollable p-0">
          <a
            class="dropdown-item"
            href="#"
            *ngFor="let entity of entities"
            attr.data-e2e="dropdown-item-{{ entity?.id }}"
            [class.is-active]="entity?.id === selectedItem?.id"
            (click)="$event.preventDefault();updateSelectedEntity(entity)"
            (keydown.enter)="$event.preventDefault();updateSelectedEntity(entity)"
            (keydown.escape)="toggleDropdown()"
            (keydown.space)="updateSelectedEntity(entity, $event)"
          >
            {{ entity.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="control search-input">
    <input
      class="input"
      type="text"
      [placeholder]="selectedItem?.placeholder || 'Search'"
      data-e2e="input-search"
      [maxLength]="400"
      [pattern]="pattern"
      [(ngModel)]="_searchTerm"
      [disabled]="disabled"
      [ngClass]="{
          'is-danger': isInputInvalid()
        }"
      #searchTermElem="ngModel"
      (change)="onSearchTermChange($event.target.value)"
      (input)="onSearchTermChange($event.target.value)"
    />
    <span *ngIf="isInputInvalid()" class="help is-danger">
      <span> {{ patternMessage }} </span>
    </span>
  </div>
</div>
